export default "__VITE_ASSET__98a74a71__"